<template>
  <div class="content-general">
    <header-session />
    <products-section />
    <services-section />
    <about-session />
    <!-- <content-session /> -->
    <contact-session />
    <clients-session />
    <footer-session />
    <a :href="url" target="_blank">
      <icon class="contact-whatsapp" description="social-whatsapp-circle" large />
    </a>
  </div>
</template>

<script>
export default {
  name: 'index-page',
  data() {
    return {
      url: 'https://web.whatsapp.com/send?phone=5531982669088',
    };
  },
  mounted() {
    if (window.innerWidth < 992) {
      this.url = 'https://api.whatsapp.com/send?phone=5531982669088';
    }
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .content-general
    width: 100%
    .contact-whatsapp
      position: fixed
      bottom: 32px
      right: 32px
      fill: #64b060
      background: $white
      z-index: 10
      opacity: .95
      border-radius: 50%
    @media (max-width: $widthTerciarySmall)
      width: 100%
</style>
